/**
 * EnvService is a service that provides environment variables.
 */
class EnvService {

    /**
     * Determines whether the application uses the BizKeyTech UI for authentication or not.
     */
    static useBizkeytechLogin = process.env.REACT_APP_USE_BIZKEYTECH_AUTH_UI === 'true';

    /**
     * Determines whether the application uses the BizLearn UI for authentication or not.
     */
    static useBizLearnLogin = process.env.REACT_APP_USE_BIZLEARN_AUTH_UI === 'true';
}


export default EnvService;
